import React from "react";
import { b2cPolicies, loginRequest } from "./authConfig";
import { Button } from '@mui/material';
import { useEffect } from "react";
import { EventType } from "@azure/msal-browser";
import { MahiContext } from "../state/MahiContext";
import { useContext } from "react";

const env = process.env.REACT_APP_ENV;


/**
 * Renders a button for Azure AD B2C SignUpSignIn user flow
 */
export const SignUpSignInButton = ({label, sx, ...props}) => {
    const mahiContext = useContext(MahiContext)
    const buttonColor = env === 'production' ? 'primary' : 'secondary';

    useEffect(() => {
        // This will be run on component mount
        const callbackId = mahiContext.msal.instance.addEventCallback(async (message) => {

            //
            // New code specific to Azure AD B2C
            //
            if (message.eventType === EventType.LOGIN_FAILURE) {
                if (message.error && message.error.errorMessage.indexOf("AADB2C90118") > -1) {
                    //
                    // Error AADB2C90118 is "The user has forgotten their password"
                    //
                    console.log('SignUpSignInButton calling loginRedirect from window.location', window.location)
                    mahiContext.msal.instance.loginRedirect(b2cPolicies.authorities.forgotPassword)
                }
            }
            if (message.eventType === EventType.LOGIN_SUCCESS || message.eventType === EventType.ACQUIRE_TOKEN_SUCCESS) {
                if (message?.payload) {
                    /**
                     * We need to reject id tokens that were not issued with the default sign-in policy.
                     * "acr" claim in the token tells us what policy is used (NOTE: for new policies (v2.0), use "tfp" instead of "acr").
                     * To learn more about B2C tokens, visit https://docs.microsoft.com/en-us/azure/active-directory-b2c/tokens-overview
                     */
                    if (message.payload.idTokenClaims["tfp"] === b2cPolicies.names.forgotPassword) {
                        console.log("Password has been reset successfully. \nPlease sign-in with your new password.")
                        return mahiContext.msal.instance.logout()
                    }
                }
            }
            //
            // End New code specific to Azure AD B2C
            //

            if (message.eventType === EventType.LOGIN_SUCCESS) {
                //
                // LOGIN_SUCCESS seems to get called twice after login.
                // Acquiring a token here is the right thing to do if the login page does not
                // call a BFF endpoint. If the login page does call the BFF we end up with
                // duplicate calls to /login
                //
                console.log('SignUpSignInButton LOGIN_SUCCESS')
                await mahiContext.acquireMahiToken();
            }
        });

        return () => {
            // This will be run on component unmount
            if (callbackId) {
                mahiContext.msal.instance.removeEventCallback(callbackId);
            }
        }
        
    // lint expects mahiContext but this causes re-renders
    // eslint-disable-next-line
    }, []);

    //
    // OAuth setup (redirecting back to app or to a blank page) for loginPopup vs loginRedirect is discussed here:
    // https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/initialization.md#choosing-an-interaction-type
    //
    const handleSignUpSignIn = (theInstance) => {
        //
        // Create a request object of the form e.g. {
        //     scopes: "openid", "email", "profile"],
        //     authority: "https://northpowermahi.b2clogin.com/northpowermahi.onmicrosoft.com/B2C_1_SignUpSignIn",
        // }
        // This is just guesswork merging two ways loginRedirect has been called in example code.
        // Mick has never seen any Microsoft documentation or example code that merges scopes and authority like this.
        //
        const signUpSignInRequest = {...loginRequest, ...b2cPolicies.authorities.signUpSignIn}

        console.log('handleSignUpSignIn started with mahiContext.msal', mahiContext.msal)
        console.log('handleSignUpSignIn from window.location', window.location)
        console.log('handleSignUpSignIn calling login redirect loginRequest', loginRequest)
        theInstance.loginRedirect(signUpSignInRequest)
                .then(() => { console.log('handleSignUpSignIn loginRedirect is done')})
                .catch(e => {
            console.log('SignUpSignIn redirect caught exception', e);
        });
    }
    return (
        <Button
            sx={sx}
            variant="contained"
            color={buttonColor}
            size="large"
            onClick={(e) => {e.stopPropagation(); handleSignUpSignIn(mahiContext.msal.instance, "redirect")}}
            {...props}
        >
            {label}
        </Button>
    )
}